import React, { useState } from "react";

const WepPagination = ({
  totalItems,
  itemsPerPage,
  onPageChange,
  attributes,
}) => {
  const { prevName, nextName, ReadMoreBgColor, ReadMoreTextColor ,showReadMoreToggler } = attributes;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
    onPageChange(page);
  };

  return (
    <div
      className="wep-pagination"
      style={{
        ...(showReadMoreToggler && {
        "--wep-pagination-bg": ReadMoreBgColor,
        "--wep-pagination-color": ReadMoreTextColor,
      }),
      }}
    >
      <button
        className="wep-prev"
        onClick={() => goToPage(currentPage - 1)}
        disabled={currentPage === 1}
      >
        {prevName}
      </button>

      {Array.from({ length: totalPages }, (_, index) => {
        const pageNumber = index + 1;
        return (
          <button
            key={index + 1}
            onClick={() => goToPage(index + 1)}
            className={currentPage === pageNumber ? "active" : ""}
          >
            {index + 1}
          </button>
        );
      })}

      <button
        className="wep-next"
        onClick={() => goToPage(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        {nextName}
      </button>
    </div>
  );
};

export default WepPagination;
